import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="header">
      {/* LEFT SIDE LOGO */}
      <div className="logo">
        <img src="/taxi-logo.png" alt="Uzhavan Taxi Logo" />
      </div>

      {/* MENU */}
      <nav className={`nav ${isOpen ? "active" : ""}`}>
        <a href="#home">Home</a>
        <a href="#about">About</a>
        <a href="#services">Services</a>
        <a href="#tariff">Tariff</a>
        <a href="#contact">Contact</a>
      </nav>

      {/* HAMBURGER */}
      <div className="hamburger" onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
};

export default Header;
